import { Flex } from '@chakra-ui/react'
import Header from './components/Header'
import Content from './components/Content'

export default function MiniCalendar() {
  return (
    <Flex w="full" flexDir="column" gap={0} h="inherit">
      <Header />
      <Content />
    </Flex>
  )
}
